import axios from '@/axios/http';
import qs from 'qs';

const wholeNetworkApi = {
  //录入-添加音乐
  addInsertMusic(params) {
    return axios.post('/entryTask/add',params);
  },
  //比对-添加音乐
  addSearchMusic(params) {
    return axios.post('/compareTask/add',params);
  },
  //录入-列表
  getList(params) {
    return axios.get(`/entryTask/entryTaskPage?${qs.stringify(params, { indices: false })}`);
  },
  //比对-列表
  compareList(params) {
    return axios.get(`/compareTask/compareTaskPage?${qs.stringify(params, { indices: false })}`);
  },
  //录入-修改音乐名称
  updateFileName(entryId,fileName) {
    return axios.put(`/entryTask/updateFileName/${entryId}/${fileName}`);
  },
  //比对-导出结果、批量导出结果
  dowmOut(params) {
    return axios.get("/compareTask/tasks/exportData?"+qs.stringify(params, { indices: false }), { responseType: 'blob' });
  },
  //比对-详情-导出结果
  dowmOutDetail(params) {
    return axios.get("/compareTaskRes/res/exportData?"+qs.stringify(params, { indices: false }), { responseType: 'blob' });
  },
  //录入-删除和批量删除接口
  delBatch(params,num) {
    if(num==0){//删除
      return axios.delete(`/entryTask/task/${params}`);
    }else{//批量删除
      return axios.put('/entryTask/tasks/batch',params);
    }
  },
  //比对-删除和批量删除接口
  delSearch(params,num) {
    if(num==0){//删除
      return axios.delete(`/compareTask/task/${params}`);
    }else{//批量删除
      return axios.put('/compareTask/tasks/batch',params);
    }
  },
  //比对-详情头部信息
  topDetail(id) {
    return axios.get('/compareTask/detail?id='+id);
  },
  //比对-详情列表信息
  ListDetail(params) {
    return axios.get('/compareTaskRes/compareTaskPage',{params});
  },
  //录入-发起对比接口
  addInitiate(params) {
    return axios.post('/compareTask/add',params);
  },
  //录入-查询待入库任务数
  getTask(id, params) {
    return axios.get('/entryTask/queryNoEntryCount');
  },
  //比对-查询待入库任务数
  getSearchTask(id, params) {
    return axios.get('/compareTask/queryNoCompareCount');
  },
  //批量导入音乐信息
  batchUpload(params) {
    return axios.post('/entryTask/importData',params);
  },

};

export default wholeNetworkApi;



// WEBPACK FOOTER //
// ./src/api/wholeNetworkApi.js